import { render, staticRenderFns } from "./BtnSelect.vue?vue&type=template&id=797d36a6&scoped=true"
import script from "./BtnSelect.vue?vue&type=script&lang=js"
export * from "./BtnSelect.vue?vue&type=script&lang=js"
import style0 from "./BtnSelect.vue?vue&type=style&index=0&id=797d36a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d36a6",
  null
  
)

export default component.exports